import React, { useEffect } from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import { REPORTS_API } from '../../../constants'
import { formatReportLegend } from '../../../utils/formatReportLegend'
import { sorter } from '../utils/sorter'

export interface IMessagesPerUser {
  rangeType: string
  searchKey: string | null
}

export interface IUseGetMessagesPerUser {
  name: string
  Max: number
}

export const useGetMessagesPerUser = (props: IMessagesPerUser) => {
  const { getAccessTokenSilently } = useAuth0()
  const [data, setData] = React.useState<IUseGetMessagesPerUser[]>([])

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          props.rangeType !== 'all_time'
            ? `${REPORTS_API}/user-message/${props.rangeType}/${props.searchKey}`
            : `${REPORTS_API}/user-message`,
          {
            headers: { 'X-Vestaboard-Token': await getAccessTokenSilently() }
          }
        )
        const json = await response.json()
        const root =
          json?.userMessagesByDay || json?.userMessagesByMonth || json?.userMessagesByWeek || json?.userMessagesByYear
        const result = Object.keys(root)
          .sort(sorter)
          .map(key => ({
            Max: root[key].max,
            name: formatReportLegend(props.rangeType, key)
          }))

        setData(result)
      } catch (e) {
        setData([])
      }
    }
    fetchData()
  }, [props.rangeType, props.searchKey, getAccessTokenSilently])

  return { data }
}
